import get from 'lodash/get';
import { COLORS } from './colors';
const { greys } = COLORS;

// primary: '#00f',
// secondary: '#00a',
// gray: '#eee',
// lightgray: '#fafafa',

const colors = {
  ...COLORS,
  text: greys.text,
  copy: COLORS.white,
  background: COLORS.background,
  darkgray: greys.dark,
  // gold
  // red
  reds: {
    light: COLORS.reds.light,
    dark: COLORS.reds.dark,
  },
  // orange

  box: greys.medium,
  flex: greys.medium,

  header: {
    background: greys.medium,
  },
  greys,
};

export const SCREEN_SIZES = {
  xs: 640,
  sm: 832,
  md: 1024,
  lg: 1440,
};

export const theme = {
  // 640px, 832px, 1024px, 1440px
  // '40em', '52em', '64em', '90em'
  breakpoints: [
    `${SCREEN_SIZES.xs}px`,
    `${SCREEN_SIZES.sm}px`,
    `${SCREEN_SIZES.md}px`,
    `${SCREEN_SIZES.lg}px`,
  ],
  space: [0, 4, 8, 16, 32, 64, 128, 256, 512],
  fontSizes: [12, 14, 16, 20, 24, 36, 48, 80, 96],
  fontWeights: [100, 200, 300, 400, 500, 600, 700, 800, 900],
  lineHeights: {
    solid: 1,
    title: 1.25,
    copy: 1.5,
  },
  fonts: ['Open Sans', 'AbhayaLibre', 'Helvetica', 'sans-serif'],
  borders: [0, '1px solid', '2px solid', `1px solid ${COLORS.cyan}`, `1px solid ${COLORS.gold}`],
  radii: [0, 2, 4, 16, 9999, '100%'],
  shadows: ['0px 5px 20px rgba(0, 0, 0, 0.1)', '0px 4px 10px #00000099'],
  sizes: [16, 32, 64, 128, 256],
  colors,
};

export function linearGradient(left: string, right: string) {
  left = get(COLORS, left);
  right = get(COLORS, right);
  return `linear-gradient(90deg, ${left} -6.96%, ${right} 97%)`;
}
